import {useEffect} from 'react';

import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';
import {useSelector} from 'react-redux';

import {getOrderLastData} from 'desktop/pages/success/store/selectors/orderLast/orderLast';

/**
 * Send non-interaction event for order in success page.
 */
export function useSendTYPAnalytics() {
    const {directContribution, status} = useSelector(getOrderLastData);

    useEffect(() => {
        if (status === 'FULFILLED') {
            pushDataLayer({
                event: 'cdc',
                eventValue: directContribution,
            });
        }
    }, [status, directContribution]);
}
